/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from "react";
import {
  CityProps,
  StateProps,
} from "../../../../../domain/models/address.model";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { FilterModel } from "../../../../../domain/models/enum";
import { TakerModel } from "../../../../../domain/models/taker";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import ButtonComponent from "../../../../components/button";
import ButtonRound from "../../../../components/button-action";
import { ItemField } from "../../../../components/datagrid";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import Icons from "../../../../components/icons-helper";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "./styles";
import TomadorComponent from "./tomador";
import { NFSeTypeEnum, NFSeTypeList } from "../../../../enums/nfs-e-type.enum";
import { NationalServiceModel } from "../../../../../domain/models/national-service";
import { NbsModel } from "../../../../../domain/models/nbs";
import { makeRemoteNationalService } from "../../../../../main/factories/usecases/national-service/remote-national-service-factory";
import { makeRemoteNbs } from "../../../../../main/factories/usecases/nbs/remote-nbs-factory";

import { makeRemoteIss } from "../../../../../main/factories/usecases/iss/remote-iss-factory";
import { getIssAliquot } from "./utils/iss";
import { formatNationalTaxCode } from "../../../../../utils/tax";
import { showErrorMessage } from "../../../../helpers/helper-toast";
import HelperMask from "../../../../helpers/helper-mask";
import { requiresObra, TIPO_LOGRADOURO_OPTIONS } from "./constants";

export const FilterFields = (setParams: any): GroupProp[] => {
  const [values, setValues] = useState<string>("");
  return [
    {
      groupName: "FILTER",
      // groupLabel: 'Tomador:',
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Nome:",
          onChange: (e) => {
            setValues(e);
          },
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorSearch",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Pesquisar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({
                    ...prev,
                    filters: `socialReason~${values}`,
                  }))
                }
              />
            </div>
          ),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorClear",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Limpar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({ ...prev, filters: null }))
                }
              />
            </div>
          ),
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};
export const Fields = (
  developerCompaniesList: DeveloperCompanyModel[],
  currentNote: any,
  setCurrentNote: any,
  setIsLoadingNote?: any,
): GroupProp[] => {
  const [companySelected, setCompanySelected] = useState<number>();
  const [aliquotIssRequired, setAliquotIssRequired] = useState<boolean>();
  const [iss, setIss] = useState<boolean>(false);

  const [showObra, setShowObra] = useState(false);
  const [obraTipo, setObraTipo] = useState<"CODIGO" | "ENDERECO">("CODIGO");

  const [nationalServices, setNationalServices] = useState<NationalServiceModel[]>([]);
  const [loadingNationalServices, setLoadingNationalServices] = useState<boolean>(false);
  const [nbsList, setNbsList] = useState<NbsModel[]>([]);
  const [loadingNbs, setLoadingNbs] = useState<boolean>(false);
  const [fetchedAliquot, setFetchedAliquot] = useState<string>("0");

  const selectedCompany = developerCompaniesList.find(
    (item) => item.id === companySelected,
  );

  const loadNationalServices = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      try {
        setLoadingNationalServices(true);
        const response = await makeRemoteNationalService().loadByCnae(initial);
        setNationalServices(response);
      } catch (error) {
        setNationalServices([]);
      } finally {
        setLoadingNationalServices(false);
      }
    })();
  };

  const loadNbs = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      try {
        setLoadingNbs(true);
        const response = await makeRemoteNbs().loadByLc116(initial);
        setNbsList(response);
      } catch (error) {
        setNbsList([]);
      } finally {
        setLoadingNbs(false);
      }
    })();
  };

  const loadIssCalculate = (nationalServiceId: number): void => {
    (async () => {
      if (!selectedCompany?.company?.id || !nationalServiceId) return;
      try {
        const response = await makeRemoteIss().calculate(selectedCompany.company.id, nationalServiceId);
        setFetchedAliquot(response.aliquot.toString().replace(".", ","));
      } catch (error) {
        setFetchedAliquot("0");
      }
    })();
  };

  useEffect(() => {
    if (currentNote) {
      if (currentNote.company) {
        setCompanySelected(currentNote.company);
        const comp = developerCompaniesList.find((c) => c.id === currentNote.company);
        if (comp) {
          setAliquotIssRequired(comp.company?.simpleNacional);
        }
      }
      if (currentNote.cnae) {
        loadNationalServices(currentNote.cnae);
      }
      if (currentNote.iss) {
        setIss(currentNote.iss === "true");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNote?.id, currentNote?.company, currentNote?.cnae, developerCompaniesList.length]);

  useEffect(() => {
    if (currentNote?.nationalService && nationalServices.length > 0) {
      const ns = nationalServices.find((n) => n.id === currentNote.nationalService);
      if (ns) {
        loadNbs(ns.complementaryLawId);
        loadIssCalculate(currentNote.nationalService);
        setShowObra(requiresObra(ns.nationalTaxCode));
        if (currentNote.obraTipo) {
          setObraTipo(currentNote.obraTipo);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalServices.length, currentNote?.nationalService, selectedCompany?.id]);

  useEffect(() => {
    if (setIsLoadingNote && currentNote) {
      const isCompanyReady = !!developerCompaniesList.find((c) => c.id === currentNote.company) || !currentNote.company;
      const isNationalServiceReady = nationalServices.some((ns) => ns.id === currentNote.nationalService) || !currentNote.nationalService;
      const isNbsReady = nbsList.some((n) => n.id === currentNote.nbs) || !currentNote.nbs;

      // When all IDs in the chain are present in the loaded lists
      if (isCompanyReady && isNationalServiceReady && isNbsReady) {
        setIsLoadingNote(false);
      }
    }
  }, [currentNote, developerCompaniesList, nationalServices, nbsList, setIsLoadingNote]);


  const tenOrMore = developerCompaniesList && developerCompaniesList?.length >= 10;

  return [
    {
      groupName: "Prestador",
      groupLabel: "Prestador:",
      items: [
        {
          name: "company",
          type: "select",
          validations: "inputRequired",
          label: "Selecione a empresa que prestou o serviço*:",
          filter: tenOrMore,
          initialValue: currentNote?.company,
          onChange: (e: any) => {
            setCompanySelected(e.value);
            setCurrentNote((prev: any) => ({ ...prev, company: e.value }));
            const selected = developerCompaniesList.find(
              (item) => item.id === e.value,
            );
            const certificate = selected?.company?.certificate;
            if (selected && !(certificate?.id || certificate?.url)) {
              showErrorMessage(
                "Esta empresa não possui certificado digital cadastrado. Não é possível emitir nota fiscal sem um certificado digital. Você pode adicioná-lo ao editar o perfil da empresa.",
              );
            }
          },
          options: developerCompaniesList?.map((el) => ({
            value: el?.id,
            label: `${HelperMask.applyCnpjMask(el.company?.subscriptionNumber || "")} — ${el.company?.socialReason}`,
            rawCnpj: (el.company?.subscriptionNumber || "").replace(/\D/g, ""),
          })),
          filterBy: "label,rawCnpj",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "tipoNota",
      groupLabel: "Tipo de Nota Fiscal:",
      items: [
        {
          name: "nfseType",
          type: "select",
          label: "Tipo de nota fiscal eletrônica:",
          options: NFSeTypeList,
          defaultValue: NFSeTypeEnum.NFS_E_NACIONAL,
          disabled: true,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "tomador",
          type: "component",
          component: (): JSX.Element => (
            <TomadorComponent
              setCurrentNote={setCurrentNote}
              currentNote={currentNote}
              selectedDeveloperId={selectedCompany?.developer?.id}
            />
          ),
        },
      ],
    },
    {
      groupName: "ISSUE",
      groupLabel: "Dados da nota fiscal: ",
      items: [
        {
          name: "competencia",
          type: "date",
          label: "Competência*: ",
          initialValue: currentNote?.competencia,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "emissionDate",
          type: "text",
          label: "Data de Emissão:",
          disabled: true,
          defaultValue: new Date().toLocaleDateString(),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "naturezaOperacao",
          type: "select",
          label: "Natureza da Operação:",
          defaultValue: "normal",
          initialValue: currentNote?.naturezaOperacao || "normal",
          options: [
            { value: "normal", label: "Normal (onerosa)" },
            { value: "bonificacao", label: "Bonificação" },
            { value: "doacao", label: "Doação" },
            { value: "remessa_brinde", label: "Remessa/Brinde" },
          ],
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "SERVICE",
      groupLabel: "Dados do Serviço:",
      items: [
        {
          name: "description",
          type: "textarea",
          label: "Discriminação do(s) serviço(s) prestado(s)*:",
          initialValue: currentNote?.description,
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "none", label: "Não Existe" },
          ],
          validations: "inputRequired",
          rows: 6,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "cnae",
          type: "select",
          label: "Atividade Econômica do Prestador(CNAE)*:",
          tooltip: "As atividades listadas baseiam-se no seu CNPJ. Caso a lista esteja incompleta, você pode atualizá-la em seu perfil recarregando os dados da empresa.",
          needsTooltip: true,
          validations: "inputRequired",
          placeholder: "00000 - Exemplo",
          initialValue: currentNote?.cnae?.id || currentNote?.cnae,
          onChange: (e: any) => {
            const selected = selectedCompany?.company?.cnaes?.find((el) => el.id === e.value);
            setCurrentNote((prev: any) => ({
              ...prev,
              cnae: e.value,
              nationalService: undefined,
              nbs: undefined,
              cnaeLabel: selected ? `${selected.codeFormatted} - ${selected.description}` : "",
            }));
          },
          filter: true,
          options: selectedCompany?.company?.cnaes?.map((el) => ({
            ...el,
            value: el?.id,
            label: `${el?.codeFormatted} - ${el.description}`,
          })),
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "nationalService",
          type: "select",
          label: "Serviço Nacional*:",
          placeholder: "Selecione o serviço nacional",
          initialValue: currentNote?.nationalService?.id || currentNote?.nationalService,
          loading: loadingNationalServices,
          disabled: loadingNationalServices,
          onChange: (e: any) => {
            const selected = nationalServices.find((ns) => ns.id === e.value);
            if (selected) {
              setCurrentNote((prev: any) => ({
                ...prev,
                nationalService: e.value,
                nbs: undefined,
                nationalServiceLabel: `${formatNationalTaxCode(selected.nationalTaxCode)} - ${selected.description}`,
              }));
            }
            // Check if obra is required
            const selectedNs = nationalServices.find((ns: any) => ns.id === e?.value);
            setShowObra(requiresObra(selectedNs?.nationalTaxCode));
            if (!requiresObra(selectedNs?.nationalTaxCode)) {
              setCurrentNote((prev: any) => ({ ...prev, obraTipo: undefined, obraCodigo: undefined, obraInscricaoImobFisc: undefined, obraAddress: undefined }));
            }
          },
          options: nationalServices.map((el) => ({
            value: el?.id,
            label: `${formatNationalTaxCode(el?.nationalTaxCode)} - ${el?.description}`,
          })),
          filter: true,
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "nbs",
          type: "select",
          label: "NBS*:",
          placeholder: "Selecione o NBS",
          initialValue: currentNote?.nbs?.id || currentNote?.nbs,
          loading: loadingNbs,
          disabled: loadingNbs,
          options: nbsList.map((el) => ({
            value: el?.id,
            label: `${el?.codigoNbs} - ${el?.description}`,
          })),
          onChange: (e: any) => {
            const selected = nbsList.find((ns) => ns.id === e.value);
            if (selected) {
              setCurrentNote((prev: any) => ({
                ...prev,
                nbs: e.value,
                nbsLabel: `${selected.codigoNbs} - ${selected.description}`,
              }));
            }
          },
          filter: true,
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    ...(showObra ? [{
      groupName: "OBRA",
      groupLabel: "Dados da Obra",
      items: [
        {
          name: "obraTipo",
          type: "radio",
          label: "Identificação da obra",
          col: { xs: 12 },
          initialValue: obraTipo,
          options: [
            { value: "CODIGO", label: "Código CNO/CEI" },
            { value: "ENDERECO", label: "Endereço" },
          ],
          validations: "inputRequired",
          onChange: (val: any) => {
            setObraTipo(val as "CODIGO" | "ENDERECO");
            setCurrentNote((prev: any) => ({ ...prev, obraTipo: val }));
          },
        },
        ...(obraTipo === "CODIGO" ? [{
          name: "obraCodigo",
          type: "text",
          label: "Código da Obra (CNO/CEI)",
          col: { xs: 12, md: 6 },
          validations: "inputRequired",
          placeholder: "Ex: 12345678901234",
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({ ...prev, obraCodigo: e?.target?.value }));
          },
        }] : [
          {
            name: "obra_zipCode",
            type: "text",
            label: "CEP da Obra",
            col: { xs: 12, md: 4 },
            validations: "inputRequired",
            mask: "99999-999",
            onChange: (e: any) => {
              const val = e?.target?.value?.replace(/\D/g, "");
              setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), zipCode: val } }));
              if (val?.length === 8) {
                fetch(`https://viacep.com.br/ws/${val}/json`)
                  .then(r => r.json())
                  .then(data => {
                    if (!data.erro) {
                      setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), zipCode: val, place: data.logradouro, district: data.bairro, state: data.uf, city: data.localidade } }));
                    }
                  }).catch(() => { /* ignore */ });
              }
            },
          },
          {
            name: "obra_tipoLogradouro",
            type: "select",
            label: "Tipo Logradouro",
            col: { xs: 12, md: 3 },
            options: TIPO_LOGRADOURO_OPTIONS,
            onChange: (e: any) => {
              setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), tipoLogradouro: e?.value } }));
            },
          },
          {
            name: "obra_place",
            type: "text",
            label: "Logradouro",
            col: { xs: 12, md: 5 },
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.place || "",
            onChange: (e: any) => {
              setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), place: e?.target?.value } }));
            },
          },
          {
            name: "obra_number",
            type: "text",
            label: "Número",
            col: { xs: 12, md: 2 },
            onChange: (e: any) => {
              setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), number: e?.target?.value } }));
            },
          },
          {
            name: "obra_district",
            type: "text",
            label: "Bairro",
            col: { xs: 12, md: 4 },
            initialValue: currentNote?.obraAddress?.district || "",
            onChange: (e: any) => {
              setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), district: e?.target?.value } }));
            },
          },
          {
            name: "obra_complement",
            type: "text",
            label: "Complemento",
            col: { xs: 12, md: 4 },
            onChange: (e: any) => {
              setCurrentNote((prev: any) => ({ ...prev, obraAddress: { ...(prev?.obraAddress || {}), complement: e?.target?.value } }));
            },
          },
          {
            name: "obra_state",
            type: "text",
            label: "Estado",
            col: { xs: 12, md: 2 },
            disabled: true,
            initialValue: currentNote?.obraAddress?.state || "",
          },
          {
            name: "obra_city",
            type: "text",
            label: "Cidade",
            col: { xs: 12, md: 4 },
            disabled: true,
            initialValue: currentNote?.obraAddress?.city || "",
          },
        ]),
        {
          name: "obraInscricaoImobFisc",
          type: "text",
          label: "Inscrição Imobiliária Fiscal",
          col: { xs: 12, md: 6 },
          placeholder: "Código fornecido pela Prefeitura (opcional)",
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({ ...prev, obraInscricaoImobFisc: e?.target?.value }));
          },
        },
      ],
    }] : []),
    {
      groupName: "VALUES",
      groupLabel: "Valores:",
      items: [
        {
          name: "serviceValue",
          type: "currency",
          label: "Valor do(s) serviço(s)*:",
          placeholder: "0,00",
          initialValue: currentNote?.serviceValue,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "unconditionalDiscount",
          type: "currency",
          disabled: false,
          label: "Desconto Incondicionado:",
          placeholder: "0,00",
          initialValue: currentNote?.unconditionalDiscount,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "conditionedDiscount",
          type: "currency",
          disabled: false,
          label: "Desconto Condicionado:",
          placeholder: "0,00",
          initialValue: currentNote?.conditionedDiscount,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "dedution",
          type: "currency",
          disabled: true,
          label: "Valor das deduções*:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },

        {
          name: "totalValue",
          type: "currency",
          disabled: true,
          label: "Valor da Nota:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "iss",
          type: "radio",
          label: "ISS Retido*:",
          initialValue: currentNote?.iss || "false",
          onChange(val) {
            const company = developerCompaniesList.find(
              (item) => item.id === companySelected,
            );
            setAliquotIssRequired(company?.company?.simpleNacional);
            setIss(val === "true");
          },
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "issAliquot",
          type: "currency",
          defaultValue: getIssAliquot(iss, fetchedAliquot, currentNote?.issAliquot || "0"),
          initialValue: (getIssAliquot(iss, fetchedAliquot, currentNote?.issAliquot) as any),
          disabled: !iss,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, issAliquot: val }));
          },
          label: "Alíquota:",
          placeholder: "0,00",
          validations: iss && aliquotIssRequired ? "inputRequired" : "",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "otherDeductions",
          type: "currency",
          disabled: false,
          label: "Outras deduções:",
          placeholder: "0,00",
          initialValue: currentNote?.otherDeductions,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
  ];
};

export const FieldsTomador = (
  data: TakerModel | null | undefined,
): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);
  const [docType, setDocType] = useState<"CNPJ" | "CPF">("CPF");

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    const defaultState = data?.address?.city?.state?.id;
    if (defaultState) {
      loadCities(defaultState);
    }

    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, [data]);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "documentTypeEnum",
          type: "radio",
          defaultValue: data?.documentTypeEnum || "CPF",
          label: "Documento*",
          onChange: (e) => {
            setDocType(e);
          },
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "NONE", label: "Não Existe" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "documentNumber",
          type: "text",
          label: "CPF/CNPJ:",
          defaultValue: data?.documentNumber,
          placeholder:
            docType === "CPF" ? "000.000.000-00" : "SS. SSS. SSS/SSSS-00",
          mask: docType === "CPF" ? "000.000.000-00" : "SS. SSS. SSS/SSSS-00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          defaultValue: data?.municipalRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          defaultValue: data?.stateRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social/Nome*:",
          defaultValue: data?.socialReason,
          placeholder: "0000000000000000000000",
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          mask: "00000-000",
          validations: "inputRequired",
          defaultValue: data?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        // {
        //   name: 'addressType',
        //   type: 'select',
        //   validations: 'objectRequired',
        //   label: 'Tipo de Endereço:',
        //   defaultValue: Number(addressTypeList?.find(
        //     (el) => el.ENUM === data?.address?.addressType,
        //   )?.value),
        //   options: addressTypeList,
        //   col: {
        //     xs: 4,
        //     md: 4,
        //     lg: 4,
        //   },
        // },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          validations: "inputRequired",
          defaultValue: data?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          validations: "inputRequired",
          defaultValue: data?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          validations: "inputRequired",
          defaultValue: data?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          defaultValue: data?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "objectRequired",
          defaultValue: data?.address?.city?.state?.id,
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "objectRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          defaultValue: data?.address?.city?.id,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          validations: "emailRequired",
          defaultValue: data?.email,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "taxSubstitute",
          type: "radio",
          defaultValue: `${data?.taxSubstitute}`,
          label: "Substituto Tributária*",
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
      ],
    },
  ];
};

export const fieldsGrid = (
  setShow: any,
  setShowGrid: any,
  setSelected: any,
): ItemField[] => [
    {
      title: "Documento",
      key: "id",
      renderItem: (data: TakerModel) => data.documentNumber,
    },
    {
      title: "Nome",
      key: "createdAt",
      renderItem: (data: TakerModel) => data.socialReason,
    },
    {
      title: "",
      key: "actions",
      renderItem: (data) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.white}
            onClick={() => {
              setSelected(data);
              setShowGrid(false);
              setShow(true);
            }}
          >
            <Icons
              height={25}
              width={25}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];
